export default __webpack_public_path__ + "static/media/anambra-logo.401cb68e.png";